<template>
  <div>
    <!-- TOOLTIPS -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              HEADER STYLES & LOGO USING
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <div class="row mt-4">
              <div class="col-10">
                <b-navbar toggleable="md"
                          type="primary"
                          variant="primary"
                >
                  <b-navbar-toggle target="nav_collapse" />
                  <b-navbar-brand href="#">
                    <img :src="require('@/assets/logos/kariyer_net_logo-white@2x.svg')"
                         alt="Kariyer.net logo white"
                         width="200"
                         height="60"
                    >
                  </b-navbar-brand>
                  <b-collapse id="nav_collapse"
                              is-nav
                  >
                    <b-navbar-nav class="ml-auto">
                      <b-nav-item-dropdown right>
                        <template slot="button-content">
                          <em>User</em>
                        </template>
                        <b-dropdown-item>Profile</b-dropdown-item>
                        <b-dropdown-item>Signout</b-dropdown-item>
                      </b-nav-item-dropdown>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-6">
                <b-navbar toggleable="md"
                          type="primary"
                          variant="primary"
                >
                  <b-navbar-toggle target="nav_collapse" />
                  <b-navbar-brand href="#">
                    <img :src="require('@/assets/logos/kariyer_net_logo-white@2x.svg')"
                         alt="Kariyer.net logo white"
                         width="200"
                         height="60"
                    >
                  </b-navbar-brand>
                  <b-collapse id="nav_collapse"
                              is-nav
                  >
                    <b-navbar-nav class="ml-auto">
                      <b-nav-item-dropdown right>
                        <template slot="button-content">
                          <em>User</em>
                        </template>
                        <b-dropdown-item>Profile</b-dropdown-item>
                        <b-dropdown-item>Signout</b-dropdown-item>
                      </b-nav-item-dropdown>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Navbar',
  data() {
    return {};
  },
  computed: {},
};
</script>
